import type { ComponentProps } from 'react'
import { cn } from '#src/cn.ts'

export function ItemTitle({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="item-title"
      className={cn(
        'flex w-fit items-center gap-2 font-medium text-sm leading-snug',
        className
      )}
      {...props}
    />
  )
}
